export const getDefaultConfig = (columns) => {
    const config = [];

    columns.forEach((column, index) => {
        config.push({
            id: column.id,
            order: index,
            visibility: column.defaultVisibility !== false,
            size: column.size,
        });
    });
    return config;
};

export const getColumnVisibility = (config) => {
    const visibility = {};

    config.forEach((column) => {
        visibility[column.id] = column.visibility;
    });

    return visibility;
};

export const getColumnOrder = (config) => {
    const order = [];

    config.forEach((column) => {
        order[column.order] = column.id;
    });
    return order;
};

export const updateColumnOrder = (config, oldIndex, newIndex) => {
    const newConfig = [...config];
    const [removed] = newConfig.splice(oldIndex, 1);

    newConfig.splice(newIndex, 0, removed);

    return newConfig.map((column, index) => {
        return {
            ...column,
            order: index,
        };
    });
};

export const getColumnSize = (columnId, config) => {
    if (config) {
        const storedSize = config.find((col) => col.id === columnId)?.size;
        return storedSize !== undefined ? storedSize : null;
    }
    return null;
};

export const compareColumns = (columns, tableConfig) => {
    // 초기 설정이 없는 경우 기본 설정으로 초기화
    if (tableConfig.length === 0) {
        const defaultConfig = getDefaultConfig(columns);
        return defaultConfig;
    }

    // 컬럼이 추가되거나 삭제된 경우에 반영하기 위한 처리
    if (tableConfig.length !== columns.length) {
        columns.forEach((column) => {
            const config = tableConfig.find((item) => item.id === column.id);
            if (!config) {
                tableConfig.push({
                    id: column.id,
                    size: column.size,
                    visibility: column.defaultVisibility === undefined ? false : column.defaultVisibility,
                    order: tableConfig.length,
                });
            }
        });

        tableConfig.forEach((config) => {
            const column = columns.find((item) => item.id === config.id);
            if (!column) {
                const index = tableConfig.findIndex((item) => item.id === config.id);
                if (index !== -1) {
                    tableConfig.splice(index, 1);
                }
            }
        });
        return tableConfig;
    }
    return tableConfig;
};
